import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Common `catch` idiom: a thrown Error's message, or `fallback` for anything else a throw can
 * carry (a string, a rejected non-Error, ...). */
export function errorMessage(err: unknown, fallback: string): string {
  return err instanceof Error ? err.message : fallback
}

/** Bytes as a one-decimal MB string, e.g. "4.2" — the shared rounding for every patch/upload size
 * shown to staff. */
export function formatMb(bytes: number): string {
  return (bytes / 1024 / 1024).toFixed(1)
}
